module.exports = __webpack_public_path__ + "static/media/reload-icon.e84c64e2.svg";